<template>
  <div class="bgImage">
    <v-container>
      <v-row>
        <v-col cols="12" md="5" sm="8" class="mx-auto mt-16 pt-16 px-md-5">
          <v-card color="basil" class="pa-md-8 pa-5">
            <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
              <v-tab v-for="item in items" :key="item">
                {{ item }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-form @submit.prevent="login()">
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field v-model="form.username" label="Username" required color="gray darken-2"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field 
                          v-model="form.password"
                          label="Password" 
                          :type="show ? 'text' : 'password'"
                          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                          color="gray darken-2"
                          required
                          @click:append="show = !show"
                          ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>

                  <div class="d-flex justify-space-between align-center py-4 px-1">
                    <div class="d-flex align-center">
                      <input type="checkbox" class="mr-2" id="vehicle1" name="vehicle1" value="Bike" color />
                      <label for="vehicle1" class="pb-0"><small>Remember</small></label>
                    </div>
                    <router-link to="#" class="black--text text-caption">Password recovery</router-link>
                  </div>
                  <div class="text-left pb-4 mt-2">
                    <v-btn depressed color="success" class="rounded py-2 px-6 white--text" type="submit">
                      Enter
                    </v-btn>
                    <v-snackbar v-model="snackbarError" color="error" min-width="250" right top>
                      <span>Email or password is wrong.</span>
                      <template v-slot:action="{ attrs }">
                        <v-btn color="gray" text v-bind="attrs" @click="snackbarError = false">
                          x
                        </v-btn>
                      </template>
                    </v-snackbar>
                  </div>
                </v-form>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
  
<script>

import { mapActions, mapGetters } from "vuex";
export default {
  name: "Login",
  data() {
    return {
      show:false, 
      snackbarError: false,
      tab: null,
      items: ["Login"],
      form: {
        username: "",
        password: "",
      },
    };
  },
  mounted(){
    this.fetchUser();
  },
  computed:{
    ...mapGetters("user",["user"])
  },
  methods: {
    ...mapActions("user", ["fetchUser"]),
    login() {
      setTimeout(() => {
        const isUserExist = this.user.find(
          (person) =>
          person.username === this.form.username &&
          person.password === this.form.password
        );
        if (isUserExist) {
          let userData = JSON.stringify(this.form);
          localStorage.setItem("userInfo",  userData);
          this.fetchUser(this.form);
          this.$router.push("/dashboard");
        } else {
          this.snackbarError = true;
        }
      }, 1000);
    },
  },
};
</script>
  
<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.bgImage {
  background-image: url("../assets/loginImage.jpg");
  width: 100%;
  height: 100%;
  background-attachment: fixed;
  background-position: center center;
  position: relative;
}

.basil {
  background-color: white;
}

.basil--text {
  color: #3db166 !important;
}

.tabs-shadow {
  box-shadow: 0 0 7px 0 rgba(10, 10, 10, 0.56);
}
</style>